/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PagedModelRequest } from './pagedModelRequest';
import { RuleCardTypeResultDetailsViewModel } from './ruleCardTypeResultDetailsViewModel';
import { PagedListMetaData } from './pagedListMetaData';

export interface RuleCardTypeResultDetailsViewModelPagedModelResponse {
  pagedRequest?: PagedModelRequest;
  data?: Array<RuleCardTypeResultDetailsViewModel> | null;
  metaData?: PagedListMetaData;
}
